import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";
 
const OOP_InlineFunctions = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Inline Functions"
      videos={[
        "https://www.youtube.com/embed/mlGNIILfVvI", // C++ Inline Function | Learn Coding
      ]}
      takeaways={[
        { text: "Learn the advantage of inline functions and their coding implementation." },
      ]}
      questions={[
        "1) Using inline functions, write a C++ program to add two matrices and demonstrate their usage in the main function. (3x3 matrix addition should be showcased).",
        "2) What is an inline function? Demonstrate and explain the inline function with an example.",
      ]}
      exampleVideos={[]} // No example question videos provided
    />
);
}

export default OOP_InlineFunctions;
